"use client";

import React from "react";
import ModalConfirmationExample from "@/examples/modals/ModalConfirmationExample";

export default function ModalConfirmationPage() {
  return (
    <div className="container mx-auto p-6">
      <ModalConfirmationExample />
    </div>
  );
}
